export function ScanlineOverlay({
  priceDirection,
}: {
  priceDirection: 'up' | 'down';
}) {
  const isUp = priceDirection === 'up';

  return (
    <>
      {/* Scanline effect */}
      <div
        className="fixed inset-0 pointer-events-none z-50 transition-opacity duration-300 ease-in-out"
        style={{
          background: `repeating-linear-gradient(
               0deg,
               transparent,
               transparent 2px,
               rgba(var(--brand-green-rgb), 0.016) 2px,
               rgba(var(--brand-green-rgb), 0.016) 4px
             )`,
          opacity: isUp ? 1 : 0,
        }}
      ></div>
      <div
        className="fixed inset-0 pointer-events-none z-50 transition-opacity duration-300 ease-in-out"
        style={{
          background: `repeating-linear-gradient(
               0deg,
               transparent,
               transparent 2px,
               rgba(var(--brand-red-rgb), 0.016) 2px,
               rgba(var(--brand-red-rgb), 0.016) 4px
             )`,
          opacity: isUp ? 0 : 1,
        }}
      ></div>

      {/* Tube-like vignette background */}
      <div
        className="fixed inset-0 pointer-events-none z-50 transition-opacity duration-300 ease-in-out"
        style={{
          background: `
            radial-gradient(
              ellipse 80% 60% at 50% 50%,
              rgba(var(--brand-green-rgb), 0.016) 60%,
              rgba(0,0,0,0.25) 100%,
              rgba(0,0,0,0.5) 100%
            )
          `,
          opacity: isUp ? 1 : 0,
        }}
      ></div>
      <div
        className="fixed inset-0 pointer-events-none z-50 transition-opacity duration-300 ease-in-out"
        style={{
          background: `
            radial-gradient(
              ellipse 80% 60% at 50% 50%,
              rgba(var(--brand-red-rgb), 0.016) 60%,
              rgba(0,0,0,0.25) 100%,
              rgba(0,0,0,0.5) 100%
            )
          `,
          opacity: isUp ? 0 : 1,
        }}
      ></div>
    </>
  );
}
